export default __webpack_public_path__ + "static/media/star.de55e211.svg";